import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { FooterServ } from "../services/api/FooterServ";

const FooterDialog = ({
  visible,
  onHide,
  footerName,
  setFooterName,
  footerContent,
  setFooterContent,
  onFooterSaved,
}) => {

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const toast = useRef(null);

  const handleClose = () => {
    setStep(1);
    setFooterName("");
    setFooterContent("");
    onHide();
  };

  // SAVE FOOTER
  const handleSaveFooter = async () => {
    try {

      setLoading(true);

      const payload = {
        name: footerName,
        content: footerContent,
      };

      await FooterServ.create(payload);

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Footer saved successfully",
        life: 3000,
      });

      if (onFooterSaved) {
        onFooterSaved();
      }

      handleClose();

    } catch (error) {

      console.log(error);

      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to save footer",
        life: 3000,
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        header="Add Footer"
        visible={visible}
        style={{ width: step === 1 ? "35rem" : "50rem" }}
        onHide={handleClose}
      >

        {/* STEP 1 */}
        {step === 1 && (
          <div className="flex flex-column gap-4">

            <div className="flex flex-column gap-2">
              <label className="font-semibold text-900">
                Footer Name
              </label>

              <InputText
                value={footerName}
                onChange={(e) => setFooterName(e.target.value)}
                placeholder="Enter footer name"
              />
            </div>

            <div className="flex justify-content-end gap-3">

              <Button
                label="Close"
                className="p-button-outlined"
                onClick={handleClose}
              />

              <Button
                label="Next"
                disabled={!footerName?.trim()}
                onClick={() => setStep(2)}
              />

            </div>

          </div>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <div className="flex flex-column gap-4">

            <div>
              <div className="text-sm text-500 mb-2">
                Footer Name
              </div>

              <div className="font-semibold text-900 text-lg">
                {footerName}
              </div>
            </div>

            <Editor
              value={footerContent}
              onTextChange={(e) =>
                setFooterContent(e.htmlValue)
              }
              style={{ height: "220px" }}
            />

            <div className="flex justify-content-between">

              <Button
                label="Back"
                className="p-button-outlined"
                onClick={() => setStep(1)}
              />

              <div className="flex gap-3">

                <Button
                  label="Close"
                  className="p-button-outlined"
                  onClick={handleClose}
                />

                <Button
                  label="Save Footer"
                  loading={loading}
                  onClick={handleSaveFooter}
                />

              </div>

            </div>

          </div>
        )}

      </Dialog>
    </>
  );
};

export default FooterDialog;